<template lang="pug">
  //- Componente que muestra el menú de configuración de las columnas de la tabla
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'b2b-table-menu-ocr-documents',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowDocumentNameOcrDocuments',
      'isShowEmailToOcrDocuments',
      'isShowStatusDocumentOcrDocuments',
      'isShowProjectOcrDocuments',
      'isShowMailServerOcrDocuments',
      'isShowDocumentTypeOcrDocuments',
      'isShowCreationDateTimeOcrDocuments',
      'isShowOcrProcessDateOcrDocuments',
      'optionsFilterService'
    ])
  },
  methods: {
    ...mapActions([
      'isShowDocumentNameOcrDocumentsAction',
      'isShowEmailToOcrDocumentsAction',
      'isShowStatusDocumentOcrDocumentsAction',
      'isShowProjectOcrDocumentsAction',
      'isShowMailServerOcrDocumentsAction',
      'isShowDocumentTypeOcrDocumentsAction',
      'isShowCreationDateTimeOcrDocumentsAction',
      'isShowOcrProcessDateOcrDocumentsAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'document-name':
          isShow = !this.isShowDocumentNameOcrDocuments
          this.isShowDocumentNameOcrDocumentsAction(isShow)
          break
        case 'email-to':
          isShow = !this.isShowEmailToOcrDocuments
          this.isShowEmailToOcrDocumentsAction(isShow)
          break
        case 'status-document':
          isShow = !this.isShowStatusDocumentOcrDocuments
          this.isShowStatusDocumentOcrDocumentsAction(isShow)
          break
        case 'project':
          isShow = !this.isShowProjectOcrDocuments
          this.isShowProjectOcrDocumentsAction(isShow)
          break
        case 'mail-server':
          isShow = !this.isShowMailServerOcrDocuments
          this.isShowMailServerOcrDocumentsAction(isShow)
          break
        case 'document-type':
          isShow = !this.isShowDocumentTypeOcrDocuments
          this.isShowDocumentTypeOcrDocumentsAction(isShow)
          break
        case 'creation-date-time':
          isShow = !this.isShowCreationDateTimeOcrDocuments
          this.isShowCreationDateTimeOcrDocumentsAction(isShow)
          break
        case 'ocr-process-date':
          isShow = !this.isShowOcrProcessDateOcrDocuments
          this.isShowOcrProcessDateOcrDocumentsAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('ocr.documents_entity_table.document_name'), value: 'document-name', show: this.isShowDocumentNameOcrDocuments
        }, {
          text: this.$t('ocr.documents_entity_table.email_from'), value: 'email-to', show: this.isShowEmailToOcrDocuments
        }, {
          text: this.$t('ocr.documents_entity_table.mail_server'), value: 'mail-server', show: this.isShowMailServerOcrDocuments
        }, {
          text: this.$t('ocr.documents_entity_table.status_document'), value: 'status-document', show: this.isShowStatusDocumentOcrDocuments
        }, {
          text: this.$t('ocr.documents_entity_table.project'), value: 'project', show: this.isShowProjectOcrDocuments
        }, {
          text: this.$t('ocr.documents_entity_table.document_type'), value: 'document-type', show: this.isShowDocumentTypeOcrDocuments
        }, {
          text: this.$t('ocr.documents_entity_table.creation_date'), value: 'creation-date-time', show: this.isShowCreationDateTimeOcrDocuments
        }, {
          text: this.$t('ocr.documents_entity_table.ocr_process_date'), value: 'ocr-process-date', show: this.isShowOcrProcessDateOcrDocuments
        }
      ]

      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        this.columns.splice(0, 1)
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
  .ods-dropdown {
    display: flex;
}
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
